import React, { useEffect, useState } from 'react';
import { apiHolder as api, apis, getIn18Text, } from 'api';
import cn from 'classnames';
import IconCard from '@web-common/components/UI/IconCard';
import { ReactComponent as IconClose } from '@/images/icons/mail/icon-close1.svg';
import { useAppSelector } from '@web-common/state/createStore';
import style from './EdmReplyFeedback.module.scss';
const dataStoreApi = api.api.getDataStoreApi();
const mailPlusCustomerApi = api.api.requireLogicalApi(apis.mailPlusCustomerApiImpl);
const EdmReplyFeedbackNoticeKey = 'edmEffectiveReplyNoticeKey';
const EdmReplyFeedback = props => {
    const { content, readOnly = false } = props;
    const { id: mid } = content || {};
    const [visible, setVisible] = useState(false);
    const currentTabType = useAppSelector(state => state.mailTabReducer.currentTab.type);
    useEffect(() => {
        const { data } = dataStoreApi.getSync(EdmReplyFeedbackNoticeKey);
        const localNotNotice = data ? JSON.parse(data) : false;
        const showReadMail = ['readMain', 'read', 'customer'].includes(currentTabType);
        const curHash = location.hash;
        let edmReplyMarkTimer;
        if (!localNotNotice && showReadMail && mid && process.env.BUILD_ISEDM && (curHash.indexOf('mailbox') >= 0 || readOnly || !curHash)) {
            edmReplyMarkTimer = setTimeout(() => {
                mailPlusCustomerApi.doGetReplyMark(mid).then(res => {
                    if (!!res.visible) {
                        setVisible(true);
                    }
                });
            }, 3000);
        }
        return () => {
            setVisible(false);
            clearTimeout(edmReplyMarkTimer);
        };
    }, [mid, location.hash, currentTabType]);
    const handleClose = () => {
        setVisible(false);
    };
    const edmReplyMarkFeedback = async (isOK) => {
        var _a, _b, _c, _d, _e;
        try {
            let params = {
                mid: mid,
                code: isOK ? 1911 : 1910,
                fromEmail: ((_c = (_b = (_a = content.sender) === null || _a === void 0 ? void 0 : _a.contact) === null || _b === void 0 ? void 0 : _b.contact) === null || _c === void 0 ? void 0 : _c.accountName) || '',
                toEmail: ((_e = (_d = content.receiver[0]) === null || _d === void 0 ? void 0 : _d.contact) === null || _e === void 0 ? void 0 : _e.contact.accountName) || '',
            };
            setVisible(false);
            let res = await mailPlusCustomerApi.edmValidReplyMarkFeedback(params);
        }
        catch (error) {
            console.log(error);
        }
    };
    const setNoMorePromptVis = () => {
        dataStoreApi.putSync(EdmReplyFeedbackNoticeKey, 'true');
        setVisible(false);
    };
    return (React.createElement("div", { style: { padding: '0px 16px' } },
        React.createElement("div", { className: style.riskReminder, hidden: !visible },
            React.createElement("div", { className: style.btnClose, onClick: handleClose },
                React.createElement(IconClose, null)),
            React.createElement("div", { className: style.intro },
                React.createElement(IconCard, { type: "warnYellow", className: style.warn }),
                React.createElement("span", { className: style.text }, getIn18Text('ZHEFENGYOUJIANDUININ'))),
            React.createElement("div", { className: style.funs },
                React.createElement("div", null,
                    React.createElement("span", { className: style.funBtn, onClick: () => edmReplyMarkFeedback(true) }, getIn18Text('SHIDEZHESHIYOUXIAO')),
                    React.createElement("span", { className: style.funBtn, onClick: () => edmReplyMarkFeedback(false) }, getIn18Text('BUSHIZHESHIWUXIAO'))),
                React.createElement("div", null,
                    React.createElement("span", { className: cn(style.funBtn, style.funBtnNoWarn), onClick: setNoMorePromptVis }, getIn18Text('BUZAITIXING')))))));
};
export default EdmReplyFeedback;
